import { render, staticRenderFns } from "./WordpressContentPage-Previews.vue?vue&type=template&id=19db993c&"
import script from "./WordpressContentPage-Previews.vue?vue&type=script&lang=js&"
export * from "./WordpressContentPage-Previews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports